import { FEATURE_MANAGEMENT } from "api/ApiPath";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { injectable } from "tsyringe";
import { FeatureRequestModel } from "./model/FeatureRequestModel";
import { FeatureResponseModel } from "./model/FeatureResponseModel";
import { UserFeatureResponseModel } from "./model/UserFeatureResponseModel";

export interface IFeatureRepository {
  getList(
    params: FeatureRequestModel,
  ): Promise<ListBaseApiResponseModel<FeatureResponseModel>>;
  getUserFeature(): Promise<ListBaseApiResponseModel<UserFeatureResponseModel>>;
  getPathWithFeature<P extends Object, R extends Object>(
    path: string,
    params: P,
  ): Promise<ListBaseApiResponseModel<R>>;
}

@injectable()
export class FeatureImpl implements IFeatureRepository {
  async getList(
    params: FeatureRequestModel,
  ): Promise<ListBaseApiResponseModel<FeatureResponseModel>> {
    return await client?.get(FEATURE_MANAGEMENT.LIST, params);
  }

  async getUserFeature(): Promise<
    ListBaseApiResponseModel<UserFeatureResponseModel>
  > {
    return await client?.get(FEATURE_MANAGEMENT.USER_FEATURE);
  }

  async getPathWithFeature<P extends Object, R extends Object>(
    path: string,
    params: P,
  ): Promise<ListBaseApiResponseModel<R>> {
    return await client?.get(path, params);
  }
}
